import { render, staticRenderFns } from "./IndividualWageTypes.vue?vue&type=template&id=2bb6a827&scoped=true&"
import script from "./IndividualWageTypes.vue?vue&type=script&lang=js&"
export * from "./IndividualWageTypes.vue?vue&type=script&lang=js&"
import style0 from "./IndividualWageTypes.vue?vue&type=style&index=0&id=2bb6a827&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb6a827",
  null
  
)

export default component.exports